// src/layouts/AppShell.jsx
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";

/**
 * Layout principal :
 * - Desktop : sidebar visible à gauche, contenu à droite.
 * - Mobile : contenu plein écran, burger flottant en haut à gauche
 *   qui ouvre/ferme le sidebar en "drawer" par-dessus.
 */
export default function AppShell({ children }) {
  const [open, setOpen] = useState(false);

  // ESC pour fermer le menu
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Empêche le scroll body quand le panneau mobile est ouvert
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Overlay mobile (clic pour fermer) */}
      {open && (
        <div
          className="fixed inset-0 z-30 bg-black/30 backdrop-blur-[1px] lg:hidden"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar :
          - mobile : drawer contrôlé par `open`
          - desktop : colonne fixe (grâce aux classes lg: dans Sidebar.jsx) */}
      <Sidebar
        isMobileOpen={open}
        onMobileClose={() => setOpen(false)}
      />

      {/* BOUTON BURGER FLOTTANT – visible uniquement sur mobile */}
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="
          fixed top-3 right-3 z-50
          inline-flex items-center justify-center
          w-9 h-9 rounded-full
          bg-white border border-slate-300
          shadow-md active:scale-95
          lg:hidden
        "
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
      >
        <span className="text-lg">{open ? "✕" : "☰"}</span>
      </button>

      {/* Contenu principal */}
      <main className="flex-1">
        <div
          className="
            w-full
            max-w-[1500px]
            mx-auto
            px-1 sm:px-3 lg:px-4
            py-4 lg:py-5
          "
        >
          {children}
        </div>
      </main>
    </div>
  );
}

